module.exports = __webpack_public_path__ + "static/img/icon_game_13.01e61f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_game_13.png
// module id = S11K
// module chunks = 0